import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './Profile.css';
import { useSelector } from 'react-redux';
import { getUserState } from '../../../store/user/selectors';
import SettingsPage from './Settings/Settings';
import PublicProfile from './PublicProfile/PublicProfile';

const ProfilePage: React.FunctionComponent = props => {
	const userProfile = useSelector(getUserState);

	if (!userProfile) {
		return <></>;
	}

	return (
		<div className="profilePage">
			<div className="profilePage__main">
				<Switch>
					<Route path="/settings">
						{userProfile.userId !== -2 ? <SettingsPage /> : <Redirect strict={true} to='/login'/>}
						
					</Route>

					<Route path="/:id">	
						<PublicProfile/>
					</Route>
				</Switch>
			</div>
		</div>
	);
}

export default ProfilePage;
